var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.toolbarClass }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.buttons.length && !_vm.scrollbars.length,
            expression: "buttons.length && !scrollbars.length",
          },
        ],
      },
      [
        _c(
          "ul",
          { staticClass: "toolbar" },
          _vm._l(_vm.buttons, function (buttonModel) {
            return _c("ObjectToolbarItemView", {
              key: buttonModel.id,
              attrs: { "button-model": buttonModel },
              on: { pressButton: _vm.pressButton },
            })
          }),
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.scrollbars.length,
            expression: "scrollbars.length",
          },
        ],
      },
      [
        _c("div", { staticClass: "toolbar scrollbars" }, [
          _c("div", { staticClass: "backButtonWrapper" }, [
            _c(
              "div",
              {
                staticClass: "bottomToolbarItem inverse",
                on: { click: _vm.closeScrollbar },
              },
              [
                _c("span", { staticClass: "fa-stack fa-2x" }, [
                  _c("i", { staticClass: "fas fa-circle fa-stack-2x" }),
                  _vm._v(" "),
                  _c("i", {
                    class: ["far fa-times", "fa-stack-1x", "fa-inverse"],
                  }),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("span", { staticClass: "subscript" }, [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(_vm.$t("buttonClose")) +
                      "\n\t\t\t\t\t"
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "scrollbarsWrapper" },
            _vm._l(_vm.scrollbars, function (scrollbarModel, i) {
              return _c("ScrollbarView", {
                key: i,
                attrs: {
                  "scrollbar-model": scrollbarModel,
                  "bar-width": _vm.scrollBarWidth,
                },
              })
            }),
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }